import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';
import { RoleEnum } from '../models';
import { AuthService } from '../services';
import { SaveCurrentUserDataAction } from './actions';

@Injectable()
export class AuthEffects {
  constructor(private authService: AuthService) {
  }

  saveCurrentUserData$ = createEffect(() => {
    return this.authService.getUser().pipe(
      filter(Boolean),
      map((user) => SaveCurrentUserDataAction({ currentUser: user, reducedRole: this.mapRole(user.role) })),
    );
  });

  private mapRole(role?: string): RoleEnum {
    if (role === undefined) {
      return null;
    }

    return (role.split(':')[1] as RoleEnum) || null;
  }
}
